import React from 'react';
import i18n from '../../../utils/ChrI18n';

const ChrFiltersLoader = () => {
 return(
  <div className="p-sm mb-2">
    <span className="text-muted fa-solid fa-spinner-scale fa-spin px-1" />
    <span className="px-1">{ i18n.t("display_string.Loading") }</span>
  </div>)
}
export default ChrFiltersLoader;